<template>
  <el-row
    v-if="fieldList && fieldList.length > 0"
    :gutter="10"
    style="height：auto"
  >
    <el-col :span="24">
      <el-card :shadow="shadow || 'never'" :class="noBorder && 'no-border'">
        <div v-if="formTitle" class="panel-title">{{ $t(formTitle) }}</div>
        <!-- 表单 -->
        <template>
          <el-form
            ref="pageform"
            :model="data"
            :rules="rules"
            size="mini"
            label-width="120px"
          >
            <el-col
              v-for="(item, index) in getConfigList()"
              v-if="item.show"
              :key="index"
              :xs="item.xs || 12"
              :sm="item.sm || 12"
              :md="item.md || 12"
              :lg="item.lg || 12"
              :xl="item.xl || 12"
            >
              <el-form-item :prop="item.value" :label="$t(item.label)" :required="item.required">
                <!-- 选择框 -->
                <el-select
                  style="width: 220px"
                  v-if="item.type === 'select'"
                  v-model="data[item.value]"
                  :label-width="item.labelWidth"
                  :disabled="item.disabled"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :filterable="item.filterable"
                  :placeholder="getPlaceholder(item)"
                  remote
                  :remote-method="(query) => remoteMethod(item, query)"
                  @focus="onFocus(item)"
                  @change="handleEvent(item.event, data[item.value])"
                >
                  <el-option
                    v-for="(childItem, childIndex) in listTypeInfo[item.list]"
                    :key="childIndex"
                    :label="childItem.key"
                    :value="childItem.value"
                  />
                </el-select>
                <!-- 数字输入框 -->
                <el-input-number
                  style="width: 220px"
                  v-else-if="item.type === 'number'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  :min="item.min || 0"
                  :max="item.max"
                  :precision="item.precision || 0"
                  controls-position="right"
                />
                <!-- 普通输入框 -->
                <el-input
                  style="width: 220px"
                  v-else-if="item.type === 'input'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :clearable="item.clearable === false ? item.clearable : true"
                  :disabled="item.disabled"
                  :readonly="item.readonly"
                  @change="(e) => handleEvent(item.event, e)"
                  @click.native="handleEvent(item.event,null)"
                />
                <!-- 密码输入框 -->
                <el-input
                  style="width: 220px"
                  v-else-if="item.type === 'password'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  type="password"
                />
                <!--多行输入框 -->
                <el-input
                  v-else-if="item.type === 'textarea'"
                  v-model="data[item.value]"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  type="textarea"
                />
                <!--远程搜索输入框 -->
                <el-autocomplete
                  v-else-if="item.type === 'autocomplete'"
                  v-model="data[item.value]"
                  :fetch-suggestions="(queryString, cb) => querySearchAsync(item, queryString, cb)"
                  :placeholder="getPlaceholder(item)"
                  :disabled="item.disabled"
                  @select="handleEvent(item.selectEvent,data[item.value])"
                ></el-autocomplete>
                <!-- 二选一单选框 -->
                <template v-else-if="item.type === 'radio'">
                  <el-radio-group
                    v-model="data[item.value]"
                    @change="(value) => handleEvent(item.event, value)"
                  >
                    <el-radio
                      :label="item.yes || 'Y'"
                      :disabled="item.disabled"
                      :placeholder="$t(item.yesLabel) || getPlaceholder(item)"
                      >{{ item.yesLabel || $t("table.yes") }}</el-radio
                    >
                    <el-radio
                      :label="item.no || 'N'"
                      :disabled="item.disabled"
                      :placeholder="$t(item.noLabel) || getPlaceholder(item)"
                      >{{ item.noLabel || $t("table.no") }}</el-radio
                    >
                  </el-radio-group>
                </template>
                <!-- 时间范围选择 -->
                <template v-else-if="item.type === 'picker'">
                  <el-col :span="11">
                    <el-time-picker
                      v-model="data[item.startTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col
                    v-if="item.startTime && item.endTime"
                    class="line text-center"
                    :span="1"
                    >-</el-col
                  >
                  <el-col :span="11">
                    <el-time-picker
                      v-model="data[item.endTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                </template>
                <!-- 日期范围选择 -->
                <el-date-picker
                  v-else-if="item.type === 'daterange'"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd"
                  type="daterange"
                  align="right"
                  unlink-panels
                  :range-separator="$t('date.to')"
                  :start-placeholder="$t('date.startDate')"
                  :end-placeholder="$t('date.endDate')"
                  :picker-options="item.options"
                />
                <el-date-picker
                  v-else-if="item.type === 'daterangeTime'"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  format="yyyy-MM-dd HH:mm"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  :range-separator="$t('date.to')"
                  :start-placeholder="$t('date.startDate')"
                  :end-placeholder="$t('date.endDate')"
                  :picker-options="item.options"
                />
                <!-- 日期选择 -->
                <el-date-picker
                  v-else-if="item.type === 'date'"
                  v-model="data[item.value]"
                  value-format="yyyy-MM-dd"
                  align="right"
                  :placeholder="getPlaceholder(item)"
                  :picker-options="pickerOptions"
                  :format="item.format || 'yyyy-MM-dd'"
                  :disabled="item.disabled"
                  @change="(e) => handleEvent(item.event, e)"
                />

                <template v-else-if="item.type === 'dateHourTime'">
                  <el-date-picker
                    v-model="data[item.value]"
                    value-format="yyyy-MM-dd HH:mm"
                    type="datetime"
                    align="right"
                    :default-value="new Date()"
                    :picker-options="pickerOptions"
                  />
                </template>
                <template v-else-if="item.type === 'dateMintuinesTime'">
                  <el-date-picker
                    v-model="data[item.value]"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    :disabled="item.disabled"
                    align="right"
                    :default-value="new Date()"
                    :picker-options="pickerOptions"
                  />
                </template>
                <!-- 日期、时间选择器 -->
                <template v-else-if="item.type === 'dateTime'">
                  <el-col v-if="item.date" :span="11">
                    <el-date-picker
                      v-model="data[item.date.value]"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      type="date"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col v-else-if="item.startTime" :span="11">
                    <el-time-picker
                      v-model="data[item.startTime.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                  <el-col
                    v-if="(item.date || item.startTime) && item.time"
                    class="line text-center"
                    :span="1"
                    >-</el-col
                  >
                  <el-col v-if="item.time" :span="11">
                    <el-time-select
                      v-if="item.time.type === 'timeSelect'"
                      v-model="data[item.time.value]"
                      :disabled="item.disabled"
                      :picker-options="{
                        start: '00:30',
                        step: '00:30',
                        end: '24:00',
                      }"
                      :placeholder="getPlaceholder(item)"
                    />
                    <el-time-picker
                      v-else
                      v-model="data[item.time.value]"
                      :placeholder="getPlaceholder(item)"
                      :disabled="item.disabled"
                      format="HH:mm"
                      value-format="HH:mm"
                      style="width: 100%"
                    />
                  </el-col>
                </template>
                <!--开关-->
                <template v-else-if="item.type === 'switch'">
                  <el-switch
                    v-model="data[item.value]"
                    :disabled="item.disabled"
                    active-color="#13ce66"
                    :active-text="item.activeText"
                    :inactive-text="item.inactiveText">
                  </el-switch>
                </template>
                <!--多选框-->
                <template v-else-if="item.type === 'checkbox'">
                  <el-checkbox-group v-model="data[item.value]" @change="(e) => handleEvent(item.event, e)">
                    <el-checkbox v-for="(checkBoxItem, index) in listTypeInfo[item.list]" :label="checkBoxItem.value" :key="index">{{checkBoxItem.key}}</el-checkbox>
                  </el-checkbox-group>
                </template>
                <!--穿梭框-->
                <template v-else-if="item.type === 'transfer'">
                  <el-transfer
                    v-model="data[item.value]"
                    :props="{
                      key: 'key',
                      label: 'label'
                    }"
                    :titles="[item.source, item.target]"
                    :data="listTypeInfo[item.list]"></el-transfer>
                </template>
                <!-- 地址选择 -->
                <div v-else-if="item.type === 'address'" class="item-inline">
                  <el-col :span="18">
                    <el-input
                      v-model="data[item.value]"
                      :disabled="item.disabled"
                      placeholder="地址"
                    />
                  </el-col>
                  <el-col :span="4">
                    <el-button
                      size="mini"
                      :disabled="item.disabled"
                      @click="handleClick(item.event)"
                      >获取经纬度</el-button
                    >
                  </el-col>
                </div>
                <!-- 城市选择 -->
                <el-cascader
                  v-else-if="item.type === 'cities'"
                  v-model="data[item.value]"
                  :props="{ value: 'label' }"
                  :options="listTypeInfo[item.list]"
                  filterable
                  style="width: 100%"
                  :disabled="item.disabled"
                />
                <!--text-->
                <div v-else-if="item.type === 'text'" class="item-info">
                  {{data[item.value]}}
                </div>
                <!--图片显示-->
                <div v-else-if="item.type === 'image'" class="block-wrap">
                  <el-image v-for="url in data[item.value]" :key="url" :src="url" fit="cover" style="width: 100px; height: 100px" :preview-src-list="data[item.value]"></el-image>
                </div>
                <!--附件下载显示-->
                <div v-else-if="item.type === 'dowloadFile'" class="item-info">
                  <ul class="attachment">
                    <li v-for="(att,index) in listTypeInfo[item.list]">
                      <a :key="index" @click="handleEvent(item.event, index)" target="_blank">{{att}}</a>
                    </li>
                  </ul>
                </div>
                <!--上传文件或者图片-->
                <template v-else-if="item.type === 'upload'">
                  <el-upload
                    class="upload-demo"
                    :action="!item.file ? file.action : item.file.action"
                    :http-request="item.file ? item.file.httpRequest: file.httpRequest"
                    :file-list="!item.file ? file.fileList : item.file.fileList"
                    :auto-upload="!item.file ? file.autoUpload : item.file.autoUpload"
                    :data="!item.file ? file.fileData : item.file.fileData"
                    v-model="!item.file ? file.fileList : item.file.fileList"
                    :accept="!item.file ? file.accept : item.file.accept"
                    :headers="!item.file ? file.headers : item.file.headers"
                    :list-type="!item.file ? file.listType : item.file.listType"
                    multiple
                    :limit="!item.file ? file.limit : item.file.limit"
                    :on-success="item.file ? item.file.onSuccess : onSuccess"
                    :on-remove="item.file ? item.file.onRemove : onRemove"
                    :before-upload="item.file ? item.file.beforeUpload: !file.type ? beforeUpload : beforeImageUpload"
                  >
                    <el-button size="small" type="primary">{{ item.buttonName }}</el-button>
                  </el-upload>
                </template>

                <!--新增数据-->
                <template v-else-if="item.type === 'addInput'">
                  <el-input v-model="data[item.value]" placeholder="" style="width: 150px;" :disabled="item.disabled"/>
                  <el-button type="primary" icon="el-icon-plus" size="mini" :disabled="item.disabled" @click="handleEvent(item.addEvent,item.value)" />
                  <span v-for="(childrenItem, index) in data[`${item.value}List`]" :key="index">
                    <template>
                      <el-divider direction="vertical" />
                      <el-input v-model="childrenItem.value" placeholder="" style="width: 150px;" :disabled="item.disabled" />
                      <el-link
                        v-show="data[`${item.value}List`] && data[`${item.value}List`].length > 0"
                        icon="el-icon-error"
                        style="color:#06c"
                        :disabled="item.disabled"
                        @click="handleEvent(item.delEvent,{ name: item.value, index })"
                      />
                    </template>
                  </span>
                </template>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <slot />
            </el-col>
          </el-form>
        </template>
      </el-card>
    </el-col>
  </el-row>
</template>
<script>
import cities from "@/common/cities"; // 引入城市数据

export default {
  props: {
    // 自定义类名
    className: {
      type: String,
    },
    //表单标题
    formTitle: {
      type: String,
    },
    // 表单数据
    data: {
      type: Object,
    },
    // 相关字段
    fieldList: {
      type: Array,
    },
    // 验证规则
    rules: {
      type: Object,
    },
    // 相关的列表
    listTypeInfo: {
      type: Object,
    },
    refObj: {
      type: Object,
    },
    //阴影效果
    shadow: {
      type: String,
    },
    //不显示边框
    noBorder: {
      type: Boolean,
    },
    //文件上传
    file: {
      type: Object,
    }
  },
  data() {
    return {
      form: {
        carriers: "全部",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      citiesOP: cities,
      pickerOptions: {
        disabledDate: (time) => {
          let nowData = new Date()
          nowData = new Date(nowData.setDate(nowData.getDate() - 1))
          return time < nowData
        }
      }
    };
  },
  computed: {
    getTableConfigList() {
      return this.table.fieldList.filter(
        (item) =>
          !item.hasOwnProperty("show") ||
          (item.hasOwnProperty("show") && item.show)
      );
    },
  },
  watch: {
    data: {
      handler: function (val) {
        // 将form实例返回到父级
        this.$emit("update:refObj", this.$refs.pageform);
      },
      deep: true, // 深度监听
    },
  },
  mounted() {
    // 将form实例返回到父级
    this.$emit("update:refObj", this.$refs.pageform);
  },
  methods: {
    // 获取字段列表
    getConfigList() {
      return this.fieldList.filter(
        (item) =>
          !item.hasOwnProperty("show") ||
          (item.hasOwnProperty("show") && item.show)
      );
    },
    // 得到placeholder的显示
    getPlaceholder(row) {
      let placeholder;
      if (row.type === "input" || row.type === "textarea") {
        placeholder = this.$t("table.input") + this.$t(row.label);
      } else if (
        row.type === "select" ||
        row.type === "time" ||
        row.type === "date" ||
        row.type === "picker"
      ) {
        placeholder = this.$t("table.select") + this.$t(row.label);
      } else if (row.type === "number") {
        placeholder = "请输入数字";
      } else {
        placeholder = this.$t(row.label);
      }
      return placeholder;
    },
    // 绑定的相关事件
    handleEvent(evnet, data) {
      this.$emit("handleEvent", evnet, data);
    },
    // 派发按钮点击事件
    handleClick(event, data) {
      this.$emit("handleClick", event, data);
    },
    //select框远程搜索
    remoteMethod(item, query) {
      item.loading = false;
      this.handleEvent(item.remoteMethod, query);
    },

    onFocus(item){
      this.handleEvent(item.onFocus, {});
    },

    //文本框搜索
    querySearchAsync(item, queryString, cb){
      this.handleEvent(item.querySearchAsync, {queryString,cb});
    },

    onSuccess(response, file, fileList) {
      this.file.fileList = fileList;
    },
    onRemove(file, fileList) {
      this.file.fileList = fileList;
    },
    beforeUpload(file) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      const isFileOrImage = /(xlsx|xls|pdf|doc|docx|dot|jpg|jpeg|png)$/.test(fileExtension);
      if (!isFileOrImage) {
        this.$message.error('只能上传【.xlsx】或【.xls】或【.pdf】或【.doc】【.docx】【.dot】文件或【jpg/png/jpeg】后缀的图片!');
        return false;
      }
      this.file.submitObj = this.file.submitObj || new FormData();
      this.file.submitObj.append("uploadFile", file);
      return true;
    },
    beforeImageUpload(file){
      const isJPGOrPNG = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/png';
      if (!isJPGOrPNG) {
        this.$message.error('图片格式不对，请选择jpg或者png或者jpeg后缀的图片!');
        return false;
      }else{
        this.file.submitObj = this.file.submitObj || new FormData();
        this.file.submitObj.append("uploadFile", file);
        return true;
      }
    }
  },
};
</script>
<style scoped>
.no-border {
  border: 0;
}
.dialog-panel .no-border .el-card__body {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog-form.vue